import {Component} from '../../core';
import {CoworkLocalitySearchComponent} from './cowork-locality-search.component'
import {CoworkPoiSearchComponent} from './cowork-poi-search.component'
import {getShortMoneyFormatCowork, capitalizeFirstLetter, showSpinner, hideSpinner} from '../../utils/common';
import {addEvent} from './coworkga';
import lozad from 'lozad'

// The initial state of this component
const initialState = {
    filter:null,
    frequency: ['Hourly', 'Daily', 'Weekly', 'Monthly'],
    typeofspace: [
        {
            'api_value': 'WORK_DESK',
            'value':'Work Desk'
        },
        {
            'api_value': 'MANAGER_CABIN',
            'value':'Manager Cabin'
        },
        {
            'api_value': 'MEETING_ROOM',
            'value':'Meeting Room'
        },
        {
            'api_value': 'TRAINING_ROOM',
            'value':'Training Room'
        },
        {
            'api_value': 'PRIVATE_CABIN',
            'value':'Private Cabin'
        },
        {
            'api_value': 'EVENT_SPACE',
            'value':'Event Space'   
        }
    ],
    availability: [
        {
            'api_value': 'ALL_DAY',
            'value':'All Days'
        },
        {
            'api_value': 'MONDAY',
            'value':'Monday'
        },
        {
            'api_value': 'TUESDAY',
            'value':'Tuesday'
        },
        {
            'api_value': 'WEDNESDAY',
            'value':'Wednesday'
        },
        {
            'api_value': 'THURSDAY',
            'value':'Thursday'
        },
        {
            'api_value': 'FRIDAY',
            'value':'Friday'   
        },
        {
            'api_value': 'SATURDAY',
            'value':'Saturday'   
        },
        {
            'api_value': 'SUNDAY',
            'value': 'Sunday'
        }

    ],
    duration: [
        {
            'api_value': 'STANDARD',
            'value':'9:00 AM - 7 PM'
        },
        {
            'api_value': 'NIGHT',
            'value':'7 PM - 9 AM'
        },
        {
            'api_value': 'ALL_DAY',
            'value':'24 hours'
        }
    ],
    amenities: ["24/7 building access", "access control", "business-class printers", "coffee", "community managers", "craft on draft", "daily cleaning", "free stationeries", "fresh drinking water", "front desk services", "global network", "mail & package handling", "nap/wellness rooms", "office-supplies", "outdoor space", "phone & meeting rooms", "professional & social events", "sipper station", "sit-to-stand desks", "unique common areas", "vehicle parking", "wireless and wired internet", "yoga"].sort(),
    price: { 'min' : [
                {
                    'value': 'Min',
                    'api_value': '0'
                },
                {
                    'value': '1000',
                    'api_value': '1000'
                },{
                    'value': '5000',
                    'api_value': '5000'
                },{
                    'value': '10000',
                    'api_value': '10000'
                },{
                    'value': '20000',
                    'api_value': '20000'
                },{
                    'value': '40000',
                    'api_value': '40000'
                },{
                    'value': '60000',
                    'api_value': '60000'
                },{
                    'value': '80000',
                    'api_value': '80000'
                },{
                    'value': '1 Lakh',
                    'api_value': '100000'
                },{
                    'value': '>1 Lakh',
                    'api_value': '200000'
                }],
                'max': [{
                    'value': 'Max',
                    'api_value': '0'
                },{
                    'value': '1000',
                    'api_value': '1000'
                },{
                    'value': '5000',
                    'api_value': '5000'
                },{
                    'value': '10000',
                    'api_value': '10000'
                },{
                    'value': '20000',
                    'api_value': '20000'
                },{
                    'value': '40000',
                    'api_value': '40000'
                },{
                    'value': '60000',
                    'api_value': '60000'
                },{
                    'value': '80000',
                    'api_value': '80000'
                },{
                    'value': '1 Lakh',
                    'api_value': '100000'
                },{
                    'value': '>1 Lakh',
                    'api_value': '200000'
                }]
            }
};


// Component fragments
const fragments = {
};

// Analytics events for this page
const analytics = {
    GA: {
        gaEventForFilter: (type) => {
            let pageType = 'SnBpage'
            addEvent('QH_CoWork', 'SnBpage_CoWork_Header', 'QH_CoWork_SnBpage_Header_Filter-Type_'+type+'_apply_click');
        }
    }
};


/**
 * Cowork Filter component
 */
export class CoworkFilterComponent extends Component {

	static alias = 'cowork-filter'; 

    constructor(el, state) {
        super(el, {...initialState, ...state});
    }

    onComponentLoaded() {

        //Bind all Events...
    	this.handleDropdownClick = this.handleDropdownClick.bind(this);
        //this.setTypeofSpaceFilter = this.setTypeofSpaceFilter.bind(this);
        this.setBudgetFilter = this.setBudgetFilter.bind(this);
        this.setFrequencyFilter = this.setFrequencyFilter.bind(this);
        this.setOtherFilter = this.setOtherFilter.bind(this);
        this.setPartnerFilter = this.setPartnerFilter.bind(this);
        this.showFilterMsite = this.showFilterMsite.bind(this);
        this.hideFilterMsite = this.hideFilterMsite.bind(this);
        this.setOtherFilterMsite = this.setOtherFilterMsite.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        

    	// Initialize the Locality filter component
        if(typeof this.state.filter !== 'undefined' && 'undefined' !==this.state.filter.cityId && this.state.filter.cityId!='') {
            let selectedlocalitys = [];

                // Build the array of selected POI ids for POIFilterComponent
            if (this.state.filter.localityIds instanceof Array) {
                selectedlocalitys = this.state.filter.localityIds.map((id, idx) => {
                    return {id, name: this.state.filter.localityNames[idx], selected: true};
                });
            }
            const localityFilterComponent = new CoworkLocalitySearchComponent(null, {
                selectedlocalitys,
                cityId: globals.cityId
            }); 

            // Watch for the Locality selected event and load the search results on locality selection
            localityFilterComponent.on('locality.selected', (localitys = []) => {
                this.state.filter.localityIds = localitys.map((locality) => locality.id);
                this.state.filter.localityNames = localitys.map((locality) => locality.name);
                //console.log(this.state.filter);
            });

            if(typeof this.setLocalityFilter !== 'undefined') {
                this.setLocalityFilter = this.setLocalityFilter.bind(this);
            }

            let selectedpois = [];

            // Build the array of selected POI ids for POIFilterComponent
            if (this.state.filter.poiIds instanceof Array) {
                selectedpois = this.state.filter.poiIds.map((id, idx) => {
                    return {id, name: this.state.filter.poiNames[idx], selected: true};
                });
            }

            const poiFilterComponent = new CoworkPoiSearchComponent(null, {
                selectedpois,
                cityId: globals.cityId
            }); 

            // Watch for the POI selected event and load the search results on poi selection
            poiFilterComponent.on('poi.selected', (pois = []) => {
                this.state.filter.poiIds = pois.map((poi) => poi.id);
                this.state.filter.poiNames = pois.map((poi) => poi.name);
            });

            if(typeof this.setPoiFilter !== 'undefined') {
                this.setPoiFilter = this.setPoiFilter.bind(this);
            }


        }
        // Initialize the Filter
        this.initializeFilter();
        this.lazyLoadCoworkPagination();
    }

    initializeFilter() {

    	//Render Filters
    	this.renderMinPrice();
    	this.renderMaxPrice();
    	this.renderTypeofSpace();
    	this.renderFrequency();
    	this.renderDuration();
    	this.renderAvailability();
    	this.renderAmenities();

    	//Handle Dropdown Hide event
    	this.refs.frequencyList.addEventListener('click', this.handleDropdownClick);
    	this.refs.durationList.addEventListener('click', this.handleDropdownClick);
    	this.refs.typeofspaceList.addEventListener('click', this.handleDropdownClick);
    	this.refs.availabilityList.addEventListener('click', this.handleDropdownClick);
    	this.refs.amenitiesList.addEventListener('click', this.handleDropdownClick);
    	this.refs.minPriceList.addEventListener('click', this.handleDropdownClick);
        this.refs.maxPriceList.addEventListener('click', this.handleDropdownClick);
        this.refs.resetFilter.addEventListener('click', this.resetFilters);
        
        if(typeof this.refs.localitySearch !== 'undefined') {
    	   this.refs.localitySearch.addEventListener('click', this.handleDropdownClick);
        }

        //Handle Filter Apply..
        if(typeof this.refs.applyLocality !== 'undefined') {
            document.getElementById('localityFilter').addEventListener('click', this.setLocalityFilter);
        }
        if(typeof this.refs.applyPoi !== 'undefined') {
            document.getElementById('poiFilter').addEventListener('click', this.setPoiFilter);
        }
        //this.refs.applyTypofspace.addEventListener('click', this.setTypeofSpaceFilter);
        this.refs.applyBudget.addEventListener('click', this.setBudgetFilter);
        //this.refs.applyFrequency.addEventListener('click', this.setFrequencyFilter);
        if(globals.mobile != "1") { 
            this.refs.otherFilters.addEventListener('click', this.setOtherFilter);
        } else {
            document.getElementById('showfiltermsite').addEventListener('click', this.showFilterMsite);
            document.getElementById('closefilter').addEventListener('click', this.hideFilterMsite);
            this.refs.otherFilters.addEventListener('click', this.setOtherFilterMsite);
        }

        if(document.getElementById('partnersId')) {
            document.getElementById('partnersId').addEventListener('click', this.setPartnerFilter);
        }

        this.setFilterCounts();

    }

    setFilterCounts() {
        if(globals.mobile != "1") { 
            let typeofspace = this.state.filter.typeofspace;
            if(typeof typeofspace !== 'undefined') {
                let lengthval = 'Type of Space';
                if(typeofspace.length==1) {
                    this.disableEnableFilter(true);
                    lengthval = typeofspace[0].replace("_", " ");
                } else if(typeofspace.length>=1) {
                    this.disableEnableFilter(true);
                    lengthval = typeofspace[0].replace("_", " ")+' + '+(typeofspace.length -1)
                } 
            } else {
                this.disableEnableFilter(false);
            }
            let frequency = this.state.filter.frequency;
            if(typeof frequency !== 'undefined' &&  typeof this.refs.frequencyText !== 'undefined') {
                if(frequency.length==1) {
                    lengthval = frequency[0];
                } else if(frequency.length>=1) {
                    lengthval = frequency[0]+' + '+(frequency.length -1)
                } 
            } 


            let location = this.state.filter.localityNames;
            if(typeof location !== 'undefined' &&  typeof this.refs.locationText !== 'undefined') {
                let lengthval = 'Location';
                if(location && location.length==1) {
                    lengthval = capitalizeFirstLetter(location[0].replace("_", " "));
                } else if(location && location.length>=1) {
                    lengthval = capitalizeFirstLetter(location[0].replace("_", " "))+' + '+(location.length -1)
                } 
                this.refs.locationText.innerText = lengthval;
            } else {
                if(this.refs.locationText){
                    this.refs.locationText.innerText = 'Location'
                }
            }

            let minPrice = this.state.filter.price.minPrice;
            let maxPrice = this.state.filter.price.maxPrice;
            if((typeof minPrice !== 'undefined' || typeof maxPrice !== 'undefined') &&  typeof this.refs.budgetText !== 'undefined') {
                let lengthval = 'Budget Range';
                if(minPrice!=0 && maxPrice == 0) {
                    lengthval = minPrice+ " -  Max";
                } 
                if(maxPrice!=0 && minPrice == 0) {
                    lengthval = "Min - "+ maxPrice;
                } 
                if(maxPrice!=0 && minPrice != 0) {
                    lengthval = minPrice + " - "+ maxPrice;
                } 

                this.refs.budgetText.innerText = lengthval;
            } else {
                this.refs.budgetText.innerText = 'Budget Range'
            }

            

            let availability = this.state.filter.availability;
            let amenity = this.state.filter.amenity;
            let poiIds = this.state.filter.poiIds;
            let duration = this.state.filter.duration
            if(typeof this.refs.desktopMoreText !== 'undefined') {
                let lengthval = (availability.length)+(duration.length)+(amenity.length)+(poiIds.length);
                if(typeof lengthval !== 'undefined' && lengthval >=1) {
                    if(lengthval > 0) {
                        this.refs.desktopMoreText.innerText = lengthval;
                        this.refs.desktopMoreText.classList.remove('hide');
                    } else {
                        this.refs.desktopMoreText.classList.add('hide');
                    }
                } else {
                    this.refs.desktopMoreText.innerText = 'More Filters'
                    this.refs.desktopMoreText.classList.add('hide');
                }
            } else {
                this.refs.desktopMoreText.innerText = 'More Filters'
                this.refs.desktopMoreText.classList.add('hide');
            }
        } else {

            if(document.getElementById('msitefiltertext')) {
                let availability = this.state.filter.availability;
                let amenity = this.state.filter.amenity;
                let poiIds = this.state.filter.poiIds;
                let duration = this.state.filter.duration;
                let typeofspace = this.state.filter.typeofspace;
                let frequency = this.state.filter.frequency;
                let location = this.state.filter.localityNames;

                if(availability.length >=1) {
                    this.refs.availabilitydd.classList.add('active');
                } else {
                    this.refs.availabilitydd.classList.remove('active');
                }
                if(duration.length >=1) {
                    this.refs.durationdd.classList.add('active');
                } else {
                    this.refs.durationdd.classList.remove('active');
                }
                if(amenity.length >=1) {
                    this.refs.amenitiesdd.classList.add('active');
                } else {
                    this.refs.amenitiesdd.classList.remove('active');
                }
                if(poiIds.length >=1) {
                    this.refs.nearbylandmarks.classList.add('active');
                } else {
                    this.refs.nearbylandmarks.classList.remove('active');
                }
                
                if(frequency.length >=1) {
                    this.refs.frequencydd.classList.add('active');
                } else {
                    if (this.refs.frequencydd) {
                        this.refs.frequencydd.classList.remove('active');
                    }
                }
                if(location && location.length >=1) {
                    this.refs.locationdd.classList.add('active');
                } else {
                    if(this.refs.locationdd){
                        this.refs.locationdd.classList.remove('active');
                    }
                }

                if(this.state.filter.price.minPrice !=0 || this.state.filter.price.maxPrice!=0) {
                    this.refs.budgetdd.classList.add('active');
                } else {
                    this.refs.budgetdd.classList.remove('active');
                }
                if(typeofspace.length >=1) {
                    this.refs.budgetdd.classList.add('active');
                    this.disableEnableFilter(true);
                    //this.refs.typeofspacedd.classList.add('active');
                } else {
                    this.disableEnableFilter(false);
                    this.refs.budgetdd.classList.remove('active');
                    //this.refs.typeofspacedd.classList.remove('active');
                }
                let lengthval = '';
                if(location){
                    lengthval = (availability.length)+(duration.length)+(amenity.length)+(typeofspace.length)+(frequency.length)+(location.length)+(poiIds.length);
                }else{
                    lengthval = (availability.length)+(duration.length)+(amenity.length)+(typeofspace.length)+(frequency.length)+(poiIds.length);
                }
             
                if(typeof lengthval !== 'undefined' && lengthval >=1) {
                    if(lengthval > 0) {
                        document.getElementById('msitefiltertext').innerText = lengthval;
                        document.getElementById('msitefiltertext').classList.remove("hide");
                    } else {
                        document.getElementById('msitefiltertext').classList.add("hide");
                        document.getElementById('msitefiltertext').innerText = 'Filters';
                    }
                } else {
                    document.getElementById('msitefiltertext').classList.add("hide");
                    document.getElementById('msitefiltertext').innerText = 'Filters';
                }
            } else {
                document.getElementById('msitefiltertext').classList.add("hide");
                document.getElementById('msitefiltertext').innerText = 'Filters';
            }
        }
    }

    showFilterMsite() {
        if(document.getElementById('coworkfilter')) {
            document.getElementById('coworkfilter').classList.add("open");
        }
    }

    hideFilterMsite() {
        if(document.getElementById('coworkfilter')) {
            document.getElementById('coworkfilter').classList.remove("open");
        }
    }

    loadFilterData(pagination) {
        if(pagination == true) {
            this.fetchFilterdata().then((response) => {
                $(".scroll-cowork").remove();
                $('#coworklistings').append(response);
                this.lazyLoadCoworkPagination();
            });
        } else {
            showSpinner();
            this.fetchFilterdata().then((response) => {
                hideSpinner();
                document.getElementById('coworklistings').innerHTML = response;
                this.getH1();
                this.lazyLoadCoworkPagination();
            });
        }
    }

    fetchFilterdata() {
        let url = '/homes/re2/coworkFilterData?aj=1';
        let data = this.state.filter;
        let postData = new FormData();
        postData.append("filter", JSON.stringify(data));
        return fetch(url, {
          method: 'POST', // or 'PUT'
          body: postData, // data can be `string` or {object}!
          }).then(res => res.text());
    }

    setLocalityFilter() {
        this.makeUrlPatterns();
        this.makeQueryParameters();
    }

    setLocalityFilter() {
        this.makeUrlPatterns();
        this.makeQueryParameters();
    }

    setTypeofSpaceFilter() {
        this.disableEnableFilter(true);
        let typeofspace = [...document.querySelectorAll('.typeofspace:checked')].map(el => el.value);
        this.state.filter.typeofspace = typeofspace; 
        //console.log(this.state.filter);
        //this.makeQueryParameters();
    }

    disableEnableFilter(type) {
        if(type == true) {
            this.refs.minPriceList.disabled = false;
            this.refs.maxPriceList.disabled = false;
            this.refs.minPriceList.classList.remove('disabled');
            this.refs.maxPriceList.classList.remove('disabled');
        } else {
            this.refs.minPriceList.disabled = true;
            this.refs.maxPriceList.disabled = true;
            this.refs.minPriceList.classList.add('disabled');
            this.refs.maxPriceList.classList.add('disabled');
        }
    }

    setPartnerFilter() {
        document.getElementById('partnersName').classList.add('hide');
        delete this.state.filter.partners; 
        this.makeQueryParameters();
    }

    setBudgetFilter() {
        this.state.filter.minPrice = this.refs.minPriceList.value;
        this.state.filter.maxPrice = this.refs.maxPriceList.value;
        this.state.filter.price.minPrice = this.refs.minPriceList.value;
        this.state.filter.price.maxPrice = this.refs.maxPriceList.value;
        //console.log(this.state.filter);
        this.makeUrlPatterns();
        this.setFilterCounts();
    }

    setFrequencyFilter() {
        this.disableEnableFilter(true);
        let frequency = [...document.querySelectorAll('.frequency:checked')].map(el => el.value);
        this.state.filter.frequency = frequency; 
        //console.log(this.state.filter);
        //this.makeQueryParameters();
    }

    setOtherFilter() {
        let availability = [...document.querySelectorAll('.availability:checked')].map(el => el.value);
        this.state.filter.availability = availability; 
        if(availability.length > 0) {
            analytics.GA.gaEventForFilter('Days_of_Availability');
        }
        let duration = [...document.querySelectorAll('.duration:checked')].map(el => el.value);
        this.state.filter.duration = duration; 
        if(duration.length > 0) {
            analytics.GA.gaEventForFilter('Duration_of_Availability');
        }
        let amenity = [...document.querySelectorAll('.amenity:checked')].map(el => el.value);
        this.state.filter.amenity = amenity; 
        if(amenity.length > 0) {
            analytics.GA.gaEventForFilter('Amenities');
        }
        let poisuggestions = [...document.querySelectorAll('.poisuggestions:checked')].map(el => el.id);
        this.state.filter.poiIds = poisuggestions; 
        if(poisuggestions.length > 0) {
            analytics.GA.gaEventForFilter('NearByLandmarks');
        }
        let poiNames = [...document.querySelectorAll('.poisuggestions:checked')].map(el => el.name);
        this.state.filter.poiNames = poiNames; 
        //console.log(this.state.filter);
        this.makeQueryParameters();
    }

    setOtherFilterMsite() {
        let availability = [...document.querySelectorAll('.availability:checked')].map(el => el.value);
        this.state.filter.availability = availability; 
        if(availability.length > 0) {
            analytics.GA.gaEventForFilter('Days_of_Availability');
        }
        let duration = [...document.querySelectorAll('.duration:checked')].map(el => el.value);
        this.state.filter.duration = duration; 
        if(duration.length > 0) {
            analytics.GA.gaEventForFilter('Duration_of_Availability');
        }
        let amenity = [...document.querySelectorAll('.amenity:checked')].map(el => el.value);
        this.state.filter.amenity = amenity; 
        if(amenity.length > 0) {
            analytics.GA.gaEventForFilter('Amenities');
        }
        let poisuggestions = [...document.querySelectorAll('.poisuggestions:checked')].map(el => el.id);
        this.state.filter.poiIds = poisuggestions; 
        if(poisuggestions.length > 0) {
            analytics.GA.gaEventForFilter('NearByLandmarks');
        }
        let poiNames = [...document.querySelectorAll('.poisuggestions:checked')].map(el => el.name);
        this.state.filter.poiNames = poiNames; 
        //console.log(this.state.filter);
        let frequency = [...document.querySelectorAll('.frequency:checked')].map(el => el.value);
        this.state.filter.frequency = frequency; 
        if(frequency.length > 0) {
            analytics.GA.gaEventForFilter('Frequency');
        }

        this.state.filter.minPrice = this.refs.minPriceList.value;
        this.state.filter.maxPrice = this.refs.maxPriceList.value;
        this.state.filter.price.minPrice = this.refs.minPriceList.value;
        this.state.filter.price.maxPrice = this.refs.maxPriceList.value;

        let typeofspace = [...document.querySelectorAll('.typeofspace:checked')].map(el => el.value);
        this.state.filter.typeofspace = typeofspace; 
        if(frequency.length > 0) {
            analytics.GA.gaEventForFilter('TypeOfSpace');
        }

        this.hideFilterMsite();
        this.setBudgetFilter();
        this.makeQueryParameters();
    }


    resetFilters() {
        this.state.filter.availability = [];
        this.state.filter.duration = []; 
        this.state.filter.amenity = [];
        this.state.filter.poiIds = [];
        this.state.filter.poiNames = [];
        this.state.filter.frequency = []; 
        this.state.filter.price.minPrice = 0;
        this.state.filter.minPrice = 0;
        this.state.filter.price.maxPrice = 0;
        this.state.filter.maxPrice = 0;
        this.state.filter.typeofspace = [];
        this.state.filter.partners = [];
        this.hideFilterMsite();
        this.renderMinPrice();
        this.renderMaxPrice();
        this.renderTypeofSpace();
        this.renderFrequency();
        this.renderDuration();
        this.renderAvailability();
        this.renderAmenities();
        this.makeQueryParameters();
    }

    makeQueryParameters() {
        let query = this.state.filter;
        query = JSON.stringify(query);
        query = btoa(query);
        query = encodeURIComponent(query);
        let _url = this.updateQueryStringParameter(location.href,'q',query);
        window.history.pushState({},"",_url);
        this.setFilterCounts();
        this.state.filter.reload = false;
        this.state.filter.currentPage = 1;
        this.loadFilterData(false);
    }

    updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }

    }

    makeUrlPatterns() {
        let defaultPath = `/coworking/coworking-spaces`;

        if(this.state.filter.city && this.state.filter.cityId && this.state.filter.cityId!="") {
            defaultPath+=`-in-`
            if(this.state.filter.localityNames && this.state.filter.localityNames[0]) {
                let localityName= (this.state.filter.localityNames[0]).replace(" ","_");
                defaultPath+=`${capitalizeFirstLetter(localityName.replace("_", " "))}-`;
            }
            defaultPath+=`${this.state.filter.city}-`;

            //Budget Based Url;
            if(this.state.filter.minPrice && this.state.filter.minPrice!='0' && this.state.filter.maxPrice && this.state.filter.maxPrice !='0') {
                defaultPath+=`from-${this.state.filter.minPrice}-to-${this.state.filter.maxPrice}`;
            }
            if(this.state.filter.minPrice==0 && this.state.filter.maxPrice!=0) {
                defaultPath+=`under-${this.state.filter.maxPrice}`;
            }
            if(this.state.filter.minPrice!=0 && this.state.filter.maxPrice==0) {
                defaultPath+=`from-${this.state.filter.minPrice}`;
            }

            if(defaultPath.charAt(defaultPath.length - 1) == '-') {
                defaultPath+=`cid_${this.state.filter.cityId}`;
            } else {
                defaultPath+=`-cid_${this.state.filter.cityId}`;
            }
            
            if(this.state.filter.localityIds && this.state.filter.localityIds[0]) {
                defaultPath+=`-lid_${this.state.filter.localityIds[0]}`;
            }
        } else {
            //Budget Based Url;
            if(this.state.filter.minPrice && this.state.filter.minPrice!='0' && this.state.filter.maxPrice && this.state.filter.maxPrice !='0') {
                defaultPath+=`-from-${this.state.filter.minPrice}-to-${this.state.filter.maxPrice}`;
            }
            if(this.state.filter.minPrice == 0 && this.state.filter.maxPrice!=0) {
                defaultPath+=`-under-${this.state.filter.maxPrice}`;
            }
            if(this.state.filter.minPrice !=0 && this.state.filter.maxPrice==0) {
                defaultPath+=`-from-${this.state.filter.minPrice}`;
            }
        }
        let query = this.state.filter;
        query = JSON.stringify(query);
        query = btoa(query);
        query = encodeURIComponent(query);
        let _url = this.updateQueryStringParameter(defaultPath.toLowerCase(),'q',query);
        window.history.pushState("", "", _url);
        this.state.filter.reload = false;
        this.state.filter.currentPage = 1;
        this.loadFilterData(false);
    }


    getH1() {
        let pricetxt =``;
        let locality =``;
        let h1 =``;
        let count = 0;
        if(document.getElementById('countresult')) {
            count = document.getElementById('countresult').value;
        }
        if(this.state.filter.city && this.state.filter.cityId && this.state.filter.cityId!="") {
            if(this.state.filter.localityNames && this.state.filter.localityNames[0]) {
                let localityName = this.state.filter.localityNames.join();
                locality+=` ${capitalizeFirstLetter(localityName.replace("_", " "))}`;
            }
            if(this.state.filter.price.minPrice && this.state.filter.price.minPrice!='0' && this.state.filter.price.maxPrice && this.state.filter.price.maxPrice !='0') {
                pricetxt += ` from ${getShortMoneyFormatCowork(this.state.filter.price.minPrice)} to ${getShortMoneyFormatCowork(this.state.filter.price.maxPrice)}`;
            }
            if(this.state.filter.price.minPrice == 0 && this.state.filter.price.maxPrice!=0) {
                pricetxt +=` below ${getShortMoneyFormatCowork(this.state.filter.price.maxPrice)}`;
            }
            if(this.state.filter.price.minPrice !=0 && this.state.filter.price.maxPrice==0) {
                pricetxt +=` from ${getShortMoneyFormatCowork(this.state.filter.price.minPrice)}`;
            }
            h1 = ` Coworking spaces${pricetxt} in${locality} ${this.state.filter.city}`;
        } else {
            if(this.state.filter.price.minPrice && this.state.filter.price.minPrice!='0' && this.state.filter.price.maxPrice && this.state.filter.price.maxPrice !='0') {
                pricetxt += ` from ${getShortMoneyFormatCowork(this.state.filter.price.minPrice)} to ${getShortMoneyFormatCowork(this.state.filter.price.maxPrice)}`;
            }
            if(this.state.filter.price.minPrice == 0 && this.state.filter.price.maxPrice!=0) {
                pricetxt +=` below ${getShortMoneyFormatCowork(this.state.filter.price.maxPrice)}`;
            }
            if(this.state.filter.price.minPrice !=0 && this.state.filter.price.maxPrice==0) {
                pricetxt +=` from ${getShortMoneyFormatCowork(this.state.filter.price.minPrice)}`;
            }
            h1 = ` Coworking spaces${pricetxt} in India`;
        }
        if(parseInt(count) > 0 ) {
            document.getElementById('coworkh1').innerHTML = `<h1>${count}${h1}</h1>`;
        } else {
            document.getElementById('coworkh1').innerHTML = '';
        }
    }
    
    renderDuration() {
    	this.refs.durationList.innerHTML = this.state.duration.reduce((html, duration, idx) => html + `
        <div class="input-div">
            <input type="checkbox" class="duration" value="${duration.api_value}"  ${(this.state.filter.duration.includes(duration.api_value))? 'checked' : ''} id="${idx}duration">
            <label for="${idx}duration"> ${duration.value}</label>
        </div>
    `, '');
    }

    renderFrequency() {
        this.refs.frequencyList.innerHTML = this.state.frequency.reduce((html, frequency, idx) => html + `
            <li>
                <div class="input-div">
                    <input type="radio" class="frequency frequencyradio" ${(this.state.filter.frequency.includes(frequency))? 'checked' : ''} value="${frequency}" id="${idx}frequency" name="11">
                    <label for="${idx}frequency"> ${frequency}</label>            
                </div>
            </li>
        `, '');

        var classname = document.getElementsByClassName("frequencyradio");
        Array.from(classname).forEach((element) => {
          element.addEventListener('click', this.setFrequencyFilter.bind(this));
        });
    }

    renderTypeofSpace() {
    	this.refs.typeofspaceList.innerHTML = this.state.typeofspace.reduce((html, typeofspace, idx) => html + `
           <li>
                <div class="input-div">
                    <input type="radio" name="a" class="typeofspace typeofspaceradio" value="${typeofspace.api_value}" ${(this.state.filter.typeofspace.includes(typeofspace.api_value))? 'checked' : ''} id="${idx}typeofspace">
                    <label for="${idx}typeofspace"> ${typeofspace.value}</label>
                </div>
           </li>
        `, '');

        var classname = document.getElementsByClassName("typeofspaceradio");
        Array.from(classname).forEach((element) => {
          element.addEventListener('click', this.setTypeofSpaceFilter.bind(this));
        });

    }

    renderAvailability() {
    	this.refs.availabilityList.innerHTML = this.state.availability.reduce((html, availability, idx) => html + `
            <div class="input-div">
                <input type="checkbox" class="availability" ${(this.state.filter.availability.includes(availability.api_value))? 'checked' : ''} value="${availability.api_value}" id="${idx}availability">
                <label for="${idx}availability"> ${availability.value}</label>
            </div>
        `, '');
    }

    renderAmenities() {
        let arrayamenities = [];
        this.state.filter.amenity.map((amenitiesfilter, i) =>  arrayamenities.push(amenitiesfilter.amenities[0]));
        this.fetchAmenitites().then((amenity) => {
            this.refs.amenitiesList.innerHTML = amenity.reduce((html, amenity, idx) => html + `
            <div class="col-sm-4">
                <small class="clearfix">${amenity.category}</small>
                ${amenity.amenity.map((item, i) => `
                    <div class="input-div">
                        <input type="checkbox" class="amenity"  ${(arrayamenities.includes(item))? 'checked' : ''} value="${item}_${amenity.category}" id="${i}${item}amenity">
                        <label for="${i}${item}amenity"> ${item}</label>
                    </div>
                  `).join('')}
            </div>
        `, '')
        });
    }

    fetchAmenitites(cityId) {
        return fetch(`/homes/re2/getAmenititesList?aj=1`).then((res) => res.json());
    }

    renderMinPrice() {
        let minPrice = this.state.filter.price.minPrice;
    	this.refs.minPriceList.innerHTML = this.state.price.min.reduce((html, minprice, idx) => html + `
    		<option class="minpriceoption" value="${minprice.api_value}" ${minPrice == minprice.api_value ? 'selected' : ''}>${minprice.value}</option>
    	`, '');

        if(document.getElementById('minpricel')) {
            document.getElementById('minpricel').addEventListener('change', function(){
                let minvalue = this.value;
                if(minvalue > 0) {
                    $('.maxpriceoption').each(function() {
                        if(parseInt(this.value) <= parseInt(minvalue)) {
                            $(this).addClass('hide');
                        } else {
                            $(this).removeClass('hide');
                        }
                    });
                } 
            });
        }
    }
    renderMaxPrice() {
        let maxPrice = this.state.filter.price.maxPrice;
    	this.refs.maxPriceList.innerHTML = this.state.price.max.reduce((html, maxprice, idx) => html + `
    		<option class="maxpriceoption" value="${maxprice.api_value}" ${maxPrice == maxprice.api_value ? 'selected' : ''}>${maxprice.value}</option>
    	`, '');

        if(document.getElementById('maxpricel')) {
            document.getElementById('maxpricel').addEventListener('change', function(){
                let maxvalue = this.value;
                if(maxvalue > 0) {
                    $('.minpriceoption').each(function() {
                        if(parseInt(this.value) >= parseInt(maxvalue)) {
                            $(this).addClass('hide');
                        } else {
                            $(this).removeClass('hide');
                        }
                    });
                }
            });
        }
    }

    lazyLoadCoworkPagination() {
        lozad('.scroll-cowork', {
            load: (el) => {
                let pageNo = el.id;
                this.state.filter.pageFrom = (parseInt(pageNo)*21);
                this.state.filter.reload = true;
                this.state.filter.currentPage = parseInt(pageNo)+1;
                this.loadFilterData(true);
            }
        }).observe();
    };

    handleDropdownClick(ev) {
    	event.stopPropagation()
    }

}
